/* eslint-disable camelcase */
import Alert from '@eduzz/fidc-alert';
import { Hidden } from '@material-ui/core';
import { Announcements } from 'components/Announcements';
import { AlertCookiesModal } from 'components/Shared/AlertCookiesModal';
import Menu from 'components/Shared/Menu';
import { createBrowserHistory } from 'history';
import { IAppRoute } from 'interfaces/route';
import { IUserToken } from 'interfaces/userToken';
import BasketFillIcon from 'mdi-react/BasketFillIcon';
import MonitorCellphone from 'mdi-react/MonitorCellphoneIcon';
import * as React from 'react';
import { Route, Router, Switch } from 'react-router';
import * as rxjs from 'rxjs';
import rxjsOperators from 'rxjs-operators';
import { alertFIDCService, IFIDCAlert } from 'services/alertFidcService';
import { analyticsG4 } from 'services/AnalyticsG4';
import authService from 'services/auth';
import { clearUser, setUser } from 'services/eduzzToolbar';
import hotjarService, { enHotjarEvents } from 'services/hotjarService';
import { ENV } from 'settings';
import OrderBump from './OrderBump';
import ProductManager from './ProductManager';
import ShowCasePhysicalElements from './ShowCasePhysicalElements';

interface IState {
  routes: IAppRoute[];
  user: IUserToken;
  fidcAlert: IFIDCAlert;
}

interface IProps {
  classes: any;
}

export const history = createBrowserHistory();

export default class AdminModule extends React.PureComponent<IProps, IState> {
  static routes: IAppRoute[] = [
    {
      path: '/customizer',
      sideDrawer: { display: 'Meus Produtos', order: 1, icon: <MonitorCellphone /> },
      component: ProductManager
    },
    {
      path: '/orderbump',
      sideDrawer: { display: 'Order Bump', order: 2, icon: <BasketFillIcon /> },
      component: OrderBump
    }
  ];

  constructor(props: IProps) {
    super(props);
    this.state = { routes: [], user: null, fidcAlert: null };
  }

  componentDidMount() {
    rxjs
      .combineLatest([authService.getUser(), authService.getUserPhoto(), hotjarService.getShowSurvey()])
      .pipe(rxjsOperators.logError(), rxjsOperators.bindComponent(this))
      .subscribe(([tempUser, photo, hasSurvey]) => {
        if (!tempUser) {
          clearUser();
          return null;
        }
        const user = {
          ...tempUser,
          photo
        };
        hotjarService.setUser(user?.id, user);

        if (hasSurvey) {
          hotjarService.submitEvent(enHotjarEvents.THREE_REGISTERED_FEATURES);
        }

        setUser(user);

        this.setState({
          routes: AdminModule.routes,
          user
        });
      });

    authService
      .getUser()
      .pipe(
        rxjsOperators.filter(user => !!user),
        rxjsOperators.take(1)
      )
      .subscribe(user => analyticsG4.config(user.id, user.belt));

    authService
      .getUser()
      .pipe(
        rxjsOperators.filter(user => !!user),
        rxjsOperators.take(1),
        rxjsOperators.switchMap(user => alertFIDCService.loadFIDCAuthorized(user?.id))
      )
      .subscribe(fidcAlert => this.setState({ fidcAlert }));
  }

  render() {
    const { user, routes, fidcAlert } = this.state;

    return (
      <Router history={history}>
        <Hidden>
          <AlertCookiesModal />
          <Menu user={user} menu={routes} />
          <div style={{ margin: '20px 20px 20px 50px' }}>
            <Alert
              application="eduzz"
              eduzzId={user?.id}
              userName={user?.name}
              env={ENV === 'production' ? 'production' : 'homolog'}
            />
            <div style={{ marginBottom: 16 }} />
            {fidcAlert?.isAuthorized && <Announcements />}
            <ShowCasePhysicalElements />
            <Switch>
              <Route exact path="/" component={ProductManager} />
              {routes.map(route => (
                <Route key={route.path} path={route.path} component={route.component} />
              ))}
            </Switch>
          </div>
        </Hidden>
      </Router>
    );
  }
}
